import { linksUtils } from '../../utils/helpers/links';
import { TranslationKey } from '@/types/i18n.types';

export { RATE_US_URLS } from '../external/external-links';

export const MOBILE_REDIRECT_URL = 'https://blocksite.onelink.me/Sk2D/Homepage';

export const TERMS = 'https://blocksite.co/terms/';
export const PRIVACY = 'https://blocksite.co/privacy';
export const CONTACT = 'https://blocksite.co/support-requests';

export interface IAboutBottomLink {
  label: TranslationKey;
  url: string;
}

export interface IAboutItem {
  title: TranslationKey;
  subtitle: TranslationKey;
  link?: {
    url: string;
    label: string;
  };
}

export const aboutItems: IAboutItem[] = [
  {
    title: 'aboutPage.createBlockListsTitle',
    subtitle: 'aboutPage.createBlockListsSubtitle',
  },
  {
    title: 'aboutPage.blockCategoriesTitle',
    subtitle: 'aboutPage.blockCategoriesSubtitle',
  },
  {
    title: 'aboutPage.rightClickMenuTitle',
    subtitle: 'aboutPage.rightClickMenuSubtitle',
  },
  {
    title: 'aboutPage.incognitoTitle',
    subtitle: 'aboutPage.incognitoSubtitle',
  },
  {
    title: 'aboutPage.keepInternetSafeTitle',
    subtitle: 'aboutPage.keepInternetSafeSubtitle',
  },
  {
    title: 'aboutPage.scheduleTitle',
    subtitle: 'aboutPage.scheduleSubtitle',
  },
  {
    title: 'aboutPage.passwordTitle',
    subtitle: 'aboutPage.passwordSubtitle',
  },

  {
    title: 'aboutPage.rateUsTitle',
    subtitle: 'aboutPage.rateUsSubtitle',
    link: {
      url: linksUtils.getRateUsUrl(),
      label: linksUtils.getRateUsUrl(),
    },
  },
];
export const bottomLinks: IAboutBottomLink[] = [
  { label: 'termsOfUse', url: TERMS },
  { label: 'privacy', url: PRIVACY },
  { label: 'contactSupport', url: CONTACT },
];
